// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage/LandingPage';
import LoginPage from './components/LoginPage/login';
import SignUpPage from './components/SignUp/signup';
import HomePage from './components/HomePage/HomePage';
import Dashboard from './components/Dashboard/dashboard';
import TaskPage from './components/TaskPage/task';
import ProfilePage from './components/ProfilePage/profile';
import WithdrawPage from './components/WithdrawPage/withdraw';
import ReferralPage from './components/ReferralPage/referral';
import SettingsPage from './components/SettingsPage/settings';

import { AuthProvider } from './components/contexts/authContext';
import PrivateRoute from './components/privateRoute';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />

          <Route path="/home" element={<PrivateRoute><HomePage /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/tasks" element={<PrivateRoute><TaskPage /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
          <Route path="/withdraw" element={<PrivateRoute><WithdrawPage /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
          <Route path="/referral" element={<PrivateRoute><ReferralPage /></PrivateRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
